import Vue from "vue";

export const check = ({ commit }) => commit("CHECK");

export const login = ({ commit }, payload) => {
  let encoded = btoa(`${payload.email}:${payload.password}`);
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("authenticate", { headers: { Authorization: `Basic ${encoded}` } })
      .then(call => {
        if (call.data.status === "ACTIVE") {
          commit("LOGIN", { token: encoded, result: call });
          resolve();
        } else {
          commit("LOGOUT");
          reject();
        }
      })
      .catch(() => {
        commit("LOGOUT");
        reject();
      });
  });
};

export const qrlogin = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Vue.$axios.get(`qr/authenticate/${payload.code}`).then(call => {
      if (call.data.status === "ACTIVE") {
        commit("LOGIN", {
          token: call.data.auth_token,
          result: call,
          auth_type: "jwt"
        });
        resolve();
      } else {
        reject();
      }
    });
  });
};

export const logout = ({ rootState, commit }) => {
  rootState.application.matchable = null;
  rootState.application.name = "you";
  rootState.contacts.items = [];
  rootState.groups.items = [];
  rootState.groups.match = {};
  rootState.users.me = {};
  rootState.users.match = {};
  commit("LOGOUT");
};
